import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { MenuItems } from '../enums/MenuItems'
import dataImportApi from '../api/dataImport/DataImportApi'
import LayoutSingleView from '../components/layout/LayoutSingleView'

function CsvImport(): React.JSX.Element {
    const [file, setFile] = useState<File | null>(null)
    const [verifyFile, setVerifyFile] = useState<File | null>(null)
    const [isLoading, setIsLoading] = useState(false)

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setFile(event.target.files[0])
        }
    }

    const handleVerifyFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        if (event.target.files) {
            setVerifyFile(event.target.files[0])
        }
    }

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault()
        if (!file) {
            alert('Please upload a file!')
            return
        }

        const formData = new FormData()
        formData.append('file', file)

        setIsLoading(true)
        try {
            await dataImportApi.importCsv(formData)
            alert('File uploaded successfully!')
        } catch (error) {
            console.error(error)
            alert(`File upload failed.\n${error}`)
        } finally {
            setIsLoading(false)
        }
    }

    const handleVerifySubmit = async (event: React.FormEvent) => {
        event.preventDefault()
        if (!verifyFile) {
            alert('Please upload a file!')
            return
        }

        const formData = new FormData()
        formData.append('file', verifyFile)

        setIsLoading(true)
        try {
            await dataImportApi.verifyCsv(formData)
            alert('csvVerify File uploaded successfully!')
        } catch (error) {
            console.error(error)
            alert(`csvVerify File upload failed.\n${error}`)
        } finally {
            setIsLoading(false)
        }
    }

    // const handleDeleteAllDataClick = async () => {
    //     if (
    //         confirm(
    //             'This will delete ALL the data in the graph with NO BACKUP.\n\nAre you sure?',
    //         )
    //     ) {
    //         setIsLoading(true)
    //         try {
    //             await dataImportApi.deleteAll()
    //             alert('Graph is empty')
    //         } catch (error) {
    //             console.error(error)
    //             alert('Deleting data failed')
    //         } finally {
    //             setIsLoading(false)
    //         }
    //     }
    // }

    return (
        <LayoutSingleView activeMenuItem={MenuItems.ImportCSV}>
            <div className="flex flex-col items-start justify-center">
                <h1 className="page-title">Linked Helper CSV Import</h1>
                <form
                    onSubmit={handleSubmit}
                    className="flex items-center gap-6 mt-8"
                >
                    <div className="flex items-center gap-6 mb-8">
                        <label className="inline-block px-6 py-2 text-base font-semibold text-white bg-blue-700 border-none rounded-lg cursor-pointer text-center transition-colors duration-300 ease shadow-md hover:bg-blue-600">
                            <input
                                type="file"
                                accept=".csv"
                                onChange={handleFileChange}
                                disabled={isLoading}
                                className="hidden"
                            />
                            Select File
                        </label>
                        {file && (
                            <span className="text-base font-medium text-[#555] overflow-hidden text-ellipsis whitespace-nowrap max-w[200px]">
                                {file.name}
                            </span>
                        )}
                        <button
                            className={`px-6 py-2 text-base font-semibold text-white bg-blue-700 border-none rounded-lg cursor-pointer transition-colors duration-300 ease shadow-md ${
                                isLoading || !file
                                    ? 'bg-gray-300 cursor-not-allowed'
                                    : 'hover:bg-green-500'
                            }`}
                            type="submit"
                            disabled={isLoading || !file}
                        >
                            {isLoading ? (
                                'Uploading...'
                            ) : (
                                <FontAwesomeIcon
                                    icon={faUpload}
                                    className="flex-shrink-0 text-xl"
                                />
                            )}
                        </button>
                    </div>
                </form>

                <h1 className="page-title">Linked Helper CSV Verify</h1>
                <p className="text-base font-medium text-[#555]">
                    This will verify the data in the graph with the data in the
                    CSV file. It will not change the data in the graph.
                </p>
                <form
                    onSubmit={handleVerifySubmit}
                    className="flex items-center gap-6 mt-8"
                >
                    <div className="flex items-center gap-6 mb-8">
                        <label className="inline-block px-6 py-2 text-base font-semibold text-white bg-blue-700 border-none rounded-lg cursor-pointer text-center transition-colors duration-300 ease shadow-md hover:bg-blue-600">
                            <input
                                type="file"
                                accept=".csv"
                                onChange={handleVerifyFileChange}
                                disabled={isLoading}
                                className="hidden"
                            />
                            Select File
                        </label>
                        {verifyFile && (
                            <span className="text-base font-medium text-[#555] overflow-hidden text-ellipsis whitespace-nowrap max-w[200px]">
                                {verifyFile.name}
                            </span>
                        )}
                        <button
                            className={`px-6 py-2 text-base font-semibold text-white bg-blue-700 border-none rounded-lg cursor-pointer transition-colors duration-300 ease shadow-md ${
                                isLoading || !verifyFile
                                    ? 'bg-gray-300 cursor-not-allowed'
                                    : 'hover:bg-green-500'
                            }`}
                            type="submit"
                            disabled={isLoading || !verifyFile}
                        >
                            {isLoading ? (
                                'Uploading...'
                            ) : (
                                <FontAwesomeIcon
                                    icon={faUpload}
                                    className="flex-shrink-0 text-xl"
                                />
                            )}
                        </button>
                    </div>
                </form>

                {/* <button
                    className="danger-button"
                    onClick={handleDeleteAllDataClick}
                    disabled={isLoading}
                >
                    Delete ALL data from graph
                </button> */}
                {isLoading && (
                    <div className="mt-4 text-base text-[#555]">
                        Loading (this may take a few minutes)...
                    </div>
                )}
            </div>
        </LayoutSingleView>
    )
}

export default CsvImport
